/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { When } from "react-if";
import { Text, Col, theme, FlexContainer } from "@nordcloud/gnui";
import { StyledRect } from "~/components";
import { formatMoney, formatMoneyWithFallback } from "~/tools";

type DataColProps = {
  cost?: string;
  forecast?: string | null;
  color: string;
  provider: string;
  showForecast: boolean;
  currency: string;
};

export function DataCol({
  cost,
  forecast,
  color,
  provider,
  showForecast,
  currency,
}: DataColProps) {
  return (
    <Col>
      <FlexContainer direction="row" alignItems="center" justifyContent="left">
        <StyledRect style={{ background: color }} />
        <Text tag="span" weight="medium" size="sm">
          {provider}
        </Text>
      </FlexContainer>
      <Text tag="span" size="sm">
        {formatMoney(cost, currency)}
      </Text>
      <When condition={showForecast}>
        <Text
          size="xs"
          tag="span"
          color={theme.color.text.text02}
          lineHeight="1.5rem"
        >
          {formatMoneyWithFallback(forecast, currency)}
        </Text>
      </When>
    </Col>
  );
}
